import { render } from "./PaysheetDashboardTab.vue?vue&type=template&id=1c8583a6"
import script from "./PaysheetDashboardTab.vue?vue&type=script&lang=js"
export * from "./PaysheetDashboardTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__